import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import GroupTitle from '../../components/peoplelist/GroupTitle';
import GroupImagesFit from '../campaign/campaign_info/GroupImagesFit';
import GroupDetailInfo from 'components/containers/group/detail/GroupDetailInfo';
import GrouProject from '../grouppage/groupdtail/GrouProject';
import GroupNavBar from 'components/containers/group/GroupNavBar';
import Groupfooter from '../campaign/Groupfooter';
import ModalText from '../modal/ModalText';
import Community from 'components/containers/community/Community';
import GroupCommunityComment from '../campaign/community/community_detail/GroupCommunityComment';
import Bottom_Modal_var2 from '../modal/Bottom_Modal_var2';
import Chating from '../chating/Chating';
import ChatingGuest from '../chating/ChatingGuest';
import TopModalbar from '../modal/TopModalbar';
import serverController from '../../server/serverController';
import server from 'server/serverController2';
import { Route, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import BottomModal from 'components/presenters/modal/BottomModal';
import FeedGallery from 'components/containers/feed/FeedGallery';
import FeedLayout from 'layouts/feed/FeedLayout';
import CenterModal from 'components/presenters/modal/CenterModal';

//날짜 출력 폼 형태
function getDateType(date) {
  function checkZero(checkString) {
    return checkString.toString().length === 1
      ? '0' + checkString
      : checkString;
  }
  let temp = `${checkZero(date.getFullYear())}-${checkZero(
    date.getMonth() + 1,
  )}-${checkZero(date.getDate())}`;
  return temp;
}

function getQueryStringObject() {
  let serachStr = window.location.search.substr(1).split('&');
  if (serachStr == '') return {};
  let result = {};
  for (let i = 0; i < serachStr.length; ++i) {
    let p = serachStr[i].split('=', 2);
    if (p.length == 1) result[p[0]] = '';
    else result[p[0]] = decodeURIComponent(p[1].replace(/\+/g, ' '));
  }
  return result;
}

const GroupInfo = ({ match }) => {
  const history = useHistory();
  const userInfo = useSelector((state) => {
    return state.userInfo;
  }); // 하단모달
  const [modalOption, setModalOption] = useState('');
  const [textModalShow, setTextModalShow] = useState(false);
  // 그룹상세
  const [groupInfo, setGroupInfo] = useState({});
  const [userImg, setUserImg] = useState('');

  const [showModalTop, setShowModalTop] = useState(false);
  const [showModalNext, setShowModalNext] = useState(false);
  const [showModalNextjoin, setShowModalNextjoin] = useState(false);
  const [modalShow, setModalShow] = useState(false);

  // 하단 모달 창 리스트
  let dataModal = [
    {
      text: '모임 수정',
      color: '#4e4e4e',
      path: `/group/modify/${match.params.group_no}`,
    },
    { text: '모임 삭제', color: '#4e4e4e' },
  ];

  const init = () => {
    dataModal[0].clickEvent = () => {
      setModalShow(false);
    };
    dataModal[1].clickEvent = () => {
      setModalShow(false);
      dataSubmit();
    };
  };
  init();

  useEffect(() => {
    if (modalOption == 'groupleave' || modalOption == 'groupjoin') {
      setTextModalShow(true);
    }
  }, [modalOption]);

  const submitClick = () => {
    setTextModalShow(false);
    if (join.is_member) {
      //member 일때
      if (showModalNextjoin) {
        //탈퇴하기 누르고 나서
        // setShowModalNextjoin(false) ;
      } else {
        // setShowModalNextjoin(true);
        deleteSubmit();
      }
    } else {
      //member가 아닐때
      if (showModalNext) {
        setShowModalNext(false);
      } else {
        setShowModalNext(true);
        setShowModalTop(true);
        joinSubmit();
      }
    }
  };

  const infoCallBack = (jsonData) => {
    if (jsonData.success !== 1) {
      if (jsonData['error'] && jsonData['error']['res_data']) {
        let errData = jsonData['error']['res_data'];
        if (errData['detail_code'] === 'PROJECT_DOES_NOT_EXIST') {
          alert('해당 프로젝트가 존재하지 않습니다.');
          history.push('/');
        } else if (errData['detail_code'] === 'GROUP_DOES_NOT_EXIST') {
          alert('해당 모임이 존재하지 않습니다.');
          history.push('/');
        } else if (
          errData['detail_code'] === 'MISSING_REQ_FOR_PRIVATE_GROUP' ||
          errData['detail_code'] === 'TOKEN_NOT_PROVIDED' ||
          errData['detail_code'] === 'GROUP_TOKEN_DOES_NOT_EXIST'
        ) {
          alert('해당 모임음 비공개 모임입니다.');
          history.goBack();
        } else if (errData['detail_code'] === 'TOKEN_MISMATCH') {
          alert('잘못된 초대 코드 입니다.');
          history.goBack();
        } else if (errData['detail_code'] === 'LOGIN_REQ') {
          alert('로그인이 필요합니다.');
          history.push('/social');
        } else if (errData['detail_code'] === 'BLOCKED_USER') {
          alert('해당 모임에 참여할 수 없습니다.');
          history.goBack();
        } else if (errData['detail_code'] === 'NOT_A_GROUP_MEMBER') {
          alert('해당 모임 참여자가 아닙니다.');
          history.goBack();
        } else if (errData['detail_code'] === 'USER_DOES_NOT_EXIST') {
          alert('유저 정보를 확인 할 수 없습니다.');
          history.goBack();
        } else {
          alert('예기치 못한 오류가 발생하였습니다.');
          history.push('/');
        }
      }
      return;
    }
    setGroupInfo(jsonData.data);
    setUserImg(
      jsonData.data.admins ? jsonData.data.admins[0].profile_img : null,
    );
  };
  useEffect(() => {
    let token = getQueryStringObject().token;
    server.getRequestData(
      `groups/${match.params.group_no}${token ? '?token=' + token : ''}`,
      infoCallBack,
    );
    server.getRequestData(
      `groups/${match.params.group_no}/projects?end_date_ge=${getDateType(
        new Date(),
      )}${token ? '&token=' + token : ''}`,
      projectsCallBack,
    );
  }, []);

  // 그룹프로젝트
  const [groupProject, setgroupProject] = useState([]);
  const projectsCallBack = (jsonData) => {
    if (jsonData.success !== 1) {
      if (jsonData['error'] && jsonData['error']['res_data']) {
        let errData = jsonData['error']['res_data'];
        alert('예기치 못한 오류가 발생하였습니다.');
        history.push('/');
      }
      return;
    }
    setgroupProject(jsonData.data.projects);
  };

  //모임 삭제
  const callBack = (res) => {
    let jsonData = res;
    if (res.success === 1) {
      history.push('/');
    } else {
      if (jsonData['error'] && jsonData['error']['res_data']) {
        let errData = jsonData['error']['res_data'];

        if (errData['detail_code'] === 'LOGIN_REQ') {
          alert('로그인이 필요합니다.');
          history.push('/social');
        } else if (errData['detail_code'] === 'NOT_AN_ADMIN') {
          alert('모임장이 아닙니다.');
        } else if (errData['detail_code'] === 'GROUP_DOES_NOT_EXIST') {
          alert('해당 모임이 존재하지 않습니다.');
          history.push('/');
        } else {
          alert('예기치 못한 오류가 발생하였습니다.');
          history.push('/');
        }
      }
    }
  };
  const dataSubmit = () => {
    let data = {};
    serverController.updateFileDeleteFetchController(
      `groups/${match.params.group_no}`,
      JSON.stringify(data),
      callBack,
    );
  };

  // 가입하기
  const joinCallBack = (res) => {
    isclick = false;
    let jsonData = res;
    if (res.success === 1) {
      window.location.reload();
    } else {
      if (jsonData['error'] && jsonData['error']['res_data']) {
        let errData = jsonData['error']['res_data'];
        if (errData['detail_code'] === 'LOGIN_REQ') {
          alert('로그인이 필요합니다.');
          history.push('/social');
        } else if (errData['detail_code'] === 'BLOCKED_USER') {
          alert('해당 모임에 참여할 수 없습니다.');
          history.goBack();
        } else if (errData['detail_code'] === 'GROUP_DOES_NOT_EXIST') {
          alert('해당 모임이 존재하지 않습니다.');
          history.push('/');
        } else if (errData['detail_code'] === 'NOT_AN_ADMIN') {
          alert('모임장이 아닙니다.');
        } else {
          alert('예기치 못한 오류가 발생하였습니다.');
          history.push('/');
        }
      }
    }
  };
  /*--click block--*/
  var isclick = false;
  const joinSubmit = () => {
    if (isclick) return;
    isclick = true;
    let data = {};
    serverController.generalPostFetchController(
      `groups/${match.params.group_no}/members`,
      JSON.stringify(data),
      joinCallBack,
    );
  };
  // 탈퇴하기
  const deleteCallBack = (res) => {
    let jsonData = res;
    if (res.success === 1) {
      // window.location.reload();
      //serverController.getServerData("auth",test);
    } else {
      if (jsonData['error'] && jsonData['error']['res_data']) {
        let errData = jsonData['error']['res_data'];
        if (errData['detail_code'] === 'LOGIN_REQ') {
          alert('로그인이 필요합니다.');
          history.push('/social');
        } else if (errData['detail_code'] === 'GROUP_DOES_NOT_EXIST') {
          alert('해당 모임이 존재하지 않습니다.');
          history.push('/');
        } else if (errData['detail_code'] === 'NOT_A_GROUP_MEMBER') {
          alert('해당 모임 참여자가 아닙니다.');
          history.goBack();
        } else {
          alert('예기치 못한 오류가 발생하였습니다.');
          history.push('/');
        }
      }
    }
  };
  const deleteSubmit = () => {
    let data = {};
    serverController.updateFileDeleteFetchController(
      `groups/${match.params.group_no}/members`,
      JSON.stringify(data),
      deleteCallBack,
    );
  };

  var join = groupInfo;
  return (
    <GroupInfoInner>
      <GroupImagesFit groupInfo={groupInfo} />
      <GroupDetailInfo
        groupInfo={groupInfo}
        fontsize={'calc(100vw*(14/375))'}
        no={`${match.params.group_no}`}
        userImg={userImg}
        userInfo={userInfo}
      />

      <GrouProject
        showModalNextjoin={showModalNextjoin}
        showModalNext={showModalNext}
        groupProject={groupProject}
        title={'진행중인 챌린지'}
        no={`${match.params.group_no}`}
        join={join}
        groupInfo={groupInfo}
        setModalOption={setModalOption}
      />
      {/* {!groupInfo.is_member ? (
        <Groupfooter
        showModalNext={showModalNext}
        bottomTxt={'모임 가입하기'}
        join={join}
        showModalNextjoin={showModalNextjoin}
        showModalNext={showModalNext}
        setModalOption={setModalOption}
        joinModal={'groupjoin'}
        leaveModal={'groupleave'}
        userInfo={userInfo}
      />
      ) : null   
      } */}

      <ModalText
        setModalOption={setModalOption}
        setTextModalShow={setTextModalShow}
        textModalShow={textModalShow}
        modalOption={modalOption}
        submitClick={submitClick}
      />
      <Bottom_Modal_var2
        data={dataModal}
        cancle={true}
        show={modalShow} //모달 보여지는 여부
        setModalShow={setModalShow}
      />
      <TopModalbar
        setShowModalTop={setShowModalTop}
        showModalTop={showModalTop}
        top={'calc(100vw*(84.5/375))'}
        text={'환영합니다! 모임 회원이 되셨습니다!'}
      />
    </GroupInfoInner>
  );
};

// 캠페인 페이지

export default function Group({ match }) {
  const userInfo = useSelector((state) => {
    return state.userInfo;
  });
  const history = useHistory();

  const [showModal, setShowModal] = useState(false);
  const [groupInfo, setGroupInfo] = useState({});
  const [isOwner, setIsOwner] = useState(false);
  //ModalState
  const [visible, setVisible] = useState(false);
  const [dataList, setDataList] = useState([]);
  //CenterModal
  const [centerModalVisible, setCenterModalVisible] = useState(false);
  const [centerModalDataList, setCenterModalDataList] = useState(null);
  const [onCenterModalComplete, setOnCenterModalComplete] = useState(null);
  const [onCenterModalCancel, setOnCenterModalCancel] = useState(null);
  const [initCenterModalState, setInitCenterModalState] = useState(false);

  const infoCallBack = (jsonData) => {
    if (jsonData.success !== 1) {
      if (jsonData['error'] && jsonData['error']['res_data']) {
        let errData = jsonData['error']['res_data'];
        if (
          errData['detail_code'] === 'PROJECT_DOES_NOT_EXIST' ||
          errData['detail_code'] === 'GROUP_DOES_NOT_EXIST' ||
          errData['detail_code'] === 'MISSING_REQ_FOR_PRIVATE_GROUP' ||
          errData['detail_code'] === 'TOKEN_NOT_PROVIDED' ||
          errData['detail_code'] === 'GROUP_TOKEN_DOES_NOT_EXIST' ||
          errData['detail_code'] === 'TOKEN_MISMATCH' ||
          errData['detail_code'] === 'LOGIN_REQ' ||
          errData['detail_code'] === 'BLOCKED_USER' ||
          errData['detail_code'] === 'NOT_A_GROUP_MEMBER' ||
          errData['detail_code'] === 'USER_DOES_NOT_EXIST'
        ) {
          //Handled By GroupInfo
        } else {
          alert('예기치 못한 오류가 발생하였습니다.');
          history.push('/');
        }
      }
      return;
    } 
    for(let i = 0; i < jsonData['data']['admins'].length; ++i)
    {
      if(jsonData['data']['admins'][i]['user_no'] === userInfo['id'])
      {
        setIsOwner(true);
        break;
      }
    }
    setGroupInfo(jsonData.data);
  }

  const deleteGroupRequest = async () => {
    try {
      const resultData = await server.deleteRequestData(`groups/${match.params.group_no}`)
      if(resultData.success === 0) {
        history.push('/');
        return;
      }
      history.replace('/');
      setVisible(false);
    } catch (error) {
      if(process.env.NODE_ENV === 'development') {
        console.error(error);
      }
    }
  }

  const exitGroupRequest = async () => {
    try {
      const resultData = await server.deleteRequestData(`groups/${match.params.group_no}/members`)
      if(resultData.success === 0) {
        return;
      }
      history.replace('/');
      setVisible(false);
    } catch (error) {
      if(process.env.NODE_ENV === 'development') {
        console.error(error);
      }
    }
  }

  const handleModal = () => {
    if(groupInfo.role === 'admin') {
      setDataList([
        {type: 'redirect', text: '수정', path: `/group/modify/${groupInfo.admins[0].group_no}`, style: {}},
        {type: 'callback', text: '삭제', callback: deleteGroupRequest, callbackParam: '', style: {color: '#DE0000'}}
      ])
    } else {
      setDataList([
        {type: 'callback', text: '탈퇴하기', callback: exitGroupRequest, style: {color: '#DE0000'}}
      ])
    }
    setVisible(!visible);
  }

  //페이지가 렌더링이 되었을 때 한번 호출
  useEffect(() => {
    serverController.getServerData(`groups/${match.params.group_no}`,infoCallBack);
  },[]);

  useEffect(() => {
    if(initCenterModalState === true)
    {
      setCenterModalVisible(false);
      setCenterModalDataList(null);
      setOnCenterModalComplete(null);
      setOnCenterModalCancel(null);
      setInitCenterModalState(false);
    }
  }, [initCenterModalState])

  return (
    <GroupInner>
      <FixedTopNav>
        <GroupTitle groupInfo={groupInfo} token={groupInfo.token} handleModal={handleModal}/>
        <GroupNavBar 
          match={match}
          setCenterModalVisible={setCenterModalVisible} 
          setCenterModalDataList={setCenterModalDataList} 
          setOnCenterModalComplete={setOnCenterModalComplete} 
          setInitCenterModalState={setInitCenterModalState} 
          userInfo={userInfo}
          groupInfo={groupInfo}
        />
        <DummySpacer></DummySpacer>
      </FixedTopNav>
      <BodyWrapper>
        <Route exact path={`/group/:group_no`} component={GroupInfo} />
        <Route exact path={`/group/:group_no/info`} component={GroupInfo} />
        <Route exact path={`/group/:group_no/community`} render={({match}) => <Community no={match['params']['group_no']} isOwner={isOwner} type='group' />} />
        <Route
          exact
          path={`/group/:group_no/post/:no`}
          component={GroupCommunityComment}
        />
        <Route exact path={`/group/:id/feed`} render={({match}) => <FeedGallery params={match['params']} type='group' />} />
        <Route
          exact
          path={`/group/:id/feed/:post`}
          render={({match}) => <FeedLayout params={match['params']} type='group' />}
        />
        {groupInfo.is_member ? (
          <Route exact path={`/group/:group_no/chating`} component={Chating} />
        ) : (
          <Route exact path={`/group/:group_no/chating`} component={ChatingGuest} />
        )}
        <BottomModal visible={visible} setVisible={setVisible} dataList={dataList}/>
        <CenterModal modalVisible={centerModalVisible} setModalVisible={setCenterModalVisible} dataList={centerModalDataList} onCancel={onCenterModalCancel} onComplete={onCenterModalComplete}/>
      </BodyWrapper>
    </GroupInner>
  );
}

const GroupInner = styled.div`
  overflow: hidden;
  height: 100vh;
  display: flex;
  flex-flow: column;
`
const FixedTopNav = styled.div`
  flex: 0 1 auto;
`;
const DummySpacer = styled.div`
  height: calc(100vw*(84/375));
`;
const BodyWrapper = styled.div`
  flex: 1 1 auto;
  overflow: hidden;
  height: 100%;
`
const GroupInfoInner = styled.div`
  overflow-y: scroll;
  height: 100%;
`;